import React, { useState } from 'react'

import "./login.scss";

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import { Form, Stack, Button, InputGroup } from 'react-bootstrap';
import { t } from 'i18next';
import { Link, useNavigate } from 'react-router-dom';

import { loginWS } from './api/loginApi';

import SnackBar from '../../components/snackbar/Snackbar';
import { gestioneSnackbar } from '../../utils/common';
import { useScreenSize } from "../../ScreenSizeContext";

function Login() {
    const navigate = useNavigate();
    const isPC = useScreenSize();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleOnSubmit = (e) => {
        e.preventDefault();

        loginWS({
            email, password,
            mobile: !isPC
        }).catch((err) => {
            gestioneSnackbar(true, err.message, "error");
        });
    }

    return (
        <div className='login-container'>
            <div>
                <Stack className='stack-login' gap={2}>
                    <div className="header-login">
                        <div><h2>{t('login.title')}</h2></div>
                        <div><p>{t('login.subtitle')}</p></div>
                    </div>
                    <Form onSubmit={(e) => handleOnSubmit(e)}>
                        <Form.Group className="mb-3" controlId="formPlaintextEmail">
                            <Form.Control className="input-login" maxLength={60} type="email" placeholder={t("common.email")}
                                value={email} onChange={(e) => setEmail(e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formPlaintextPassword">
                            <InputGroup>
                                <Form.Control
                                    className="input-login"
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <InputGroup.Text className="input-login" onClick={togglePasswordVisibility} style={{ cursor: "pointer" }}>
                                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                </InputGroup.Text>
                            </InputGroup>
                        </Form.Group>
                        <Button type="submit" className='button-login' variant="light" size="md"
                            active>
                            {t("login.title")}
                        </Button>
                        <div className='forget-password-link'>
                            <Link to="../forget-password" className='secondary-text-link'>{t("login.forget_password")}</Link>
                        </div>
                    </Form>
                </Stack>
            </div>
            <div >
                <Link to="../registration" className='secondary-text-link'>{t("login.registration")}<b> {t("login.registration_on_platform")}</b></Link>
            </div>
            <SnackBar />
        </div >
    )
}

export default Login
